export const MOBILE_NETWORKS = [
  {
    value: "at",
    label: "AT (AirtelTigo)",
    shortLabel: "AT",
    logo: "/images/networks/at.png",
  },
  {
    value: "telecel",
    label: "Telecel",
    shortLabel: "Telecel",
    logo: "/images/networks/telecel.png",
  },
  {
    value: "mtn",
    label: "MTN",
    shortLabel: "MTN",
    logo: "/images/networks/mtn.png",
  },
];

export const MOBILE_NETWORK_VALUES = MOBILE_NETWORKS.map((n) => n.value);

export function isValidMobileNetwork(value) {
  return MOBILE_NETWORK_VALUES.includes(String(value || "").trim().toLowerCase());
}
